/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Connect_Point_3Inputs */

const en_landing_step_connect_point_3 = /** @type {(inputs: Landing_Step_Connect_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence Hub ready if you would rather not build one`)
};

/**
* | output |
* | --- |
* | "Intelligence Hub ready if you would rather not build one" |
*
* @param {Landing_Step_Connect_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_connect_point_3 = /** @type {((inputs?: Landing_Step_Connect_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Connect_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_connect_point_3(inputs)
});